import { render, staticRenderFns } from "./productSaleRank.vue?vue&type=template&id=d9520ee6&scoped=true"
import script from "./productSaleRank.vue?vue&type=script&lang=ts"
export * from "./productSaleRank.vue?vue&type=script&lang=ts"
import style0 from "./productSaleRank.vue?vue&type=style&index=0&id=d9520ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9520ee6",
  null
  
)

export default component.exports